import HtmlContent from '../../components/common/HtmlContent.jsx';
import LoadingState from '../../components/common/LoadingState.jsx';
import PageHero from '../../components/common/PageHero.jsx';
import Seo from '../../components/common/Seo.jsx';
import { useContent } from '../../hooks/useContent.js';
import { assetUrl } from '../../services/storefrontService.js';

export default function ServicesPage() {
  const { content, status } = useContent();

  if (status === 'loading') return <LoadingState label="Loading services" />;

  const services = content.services || [];

  return (
    <>
      <Seo
        title="Services"
        description="Shipping within 24 hours, easy 15-day returns, and product guidance from La Bella Trading — natural Mediterranean honey, olive oil, and soaps."
        path="/services"
      />
      <PageHero
        eyebrow="Services"
        title="Natural Product Care"
        text="Support, sourcing, and product guidance from La Bella Trading."
        image="assets/uploads/banner.jpg"
      />
      <section className="container page-section">
        <div className="service-grid">
          {services.map((service) => (
            <article className="service-card" key={service.id}>
              {service.image ? <img src={assetUrl(service.image)} alt="" /> : null}
              <div>
                <h2>{service.title}</h2>
                <HtmlContent className="rich-text" html={service.content} />
              </div>
            </article>
          ))}
        </div>
      </section>
    </>
  );
}
